import { useAuth } from "../context/AuthContext";

const UserInfo = ({ showDetailed = false }) => {
  const { client } = useAuth();

  if (!client) {
    return (
      <div className="alert alert-warning">
        Aucun utilisateur connecté
      </div>
    );
  }

  if (showDetailed) {
    return (
      <div className="card mb-3">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">👤 Informations utilisateur</h5>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <p><strong>Email :</strong> {client.email}</p>
              <p><strong>Rôle :</strong> {client.role || 'Utilisateur'}</p>
            </div>
            <div className="col-md-6">
              {client.nom && <p><strong>Nom :</strong> {client.nom}</p>}
              {client.prenom && <p><strong>Prénom :</strong> {client.prenom}</p>}
              {client.id && <p><strong>ID :</strong> {client.id}</p>}
              {client.telephone && <p><strong>Téléphone :</strong> {client.telephone}</p>}
            </div>
          </div>
          {client.dateCreation && (
            <p className="text-muted small mb-0">
              <strong>Membre depuis :</strong> {new Date(client.dateCreation).toLocaleDateString('fr-FR')}
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="d-inline-flex align-items-center gap-2">
      <span className="badge bg-primary">
        {client.role || 'Utilisateur'}
      </span>
      <span className="text-muted">
        {client.nom || client.prenom || client.email}
      </span>
    </div>
  );
};

export default UserInfo;
